module.exports = __webpack_public_path__ + "img/Group 1025.1e294881.png";